module.exports = __webpack_public_path__ + "preview-eac7acfc/prompt-regular-a8979f5fddba897421a7a2f12df91df3.ttf";